import { createAsyncThunk } from "@reduxjs/toolkit";
import { DEVICES_TYPES } from "app/reducers/devicesSlice";
import { axios } from "config/api";
import {
  CreateDeviceRequest,
  DeleteDeviceRequest,
} from "interfaces/requests/Devices";

const BASE_URL = "/devices";

//! TO.DO Update corresponding functions requests, urls and deviceType handlers.

export const fetchDevices = createAsyncThunk("devices/get", async () => {
  try {
    const response = await axios.get(`${BASE_URL}/`);
    return response.data.data;
  } catch (error: any) {
    console.log("Error - fetchDevices ->", error);
    throw new Error(error.message);
  }
});

export const addDevice = createAsyncThunk(
  "devices/add",
  async ({ request, deviceType }: CreateDeviceRequest) => {
    try {
      const url = deviceType === DEVICES_TYPES.TABLET ? "/tablets" : "/devices";
      const response = await axios.post(`${url}/`, request);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - addDevice ->", error);
      throw new Error(error.message);
    }
  },
);

export const removeDevice = createAsyncThunk(
  "devices/remove",
  async ({ request, deviceType }: DeleteDeviceRequest) => {
    try {
      const url = deviceType === DEVICES_TYPES.TABLET ? "/tablets" : "/devices";
      const response = await axios.put(`${url}/delete/${request._id}`);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - removeDevice ->", error);
      throw new Error(error.message);
    }
  },
);
